import { Button } from 'semantic-ui-react';
import styled from 'styled-components';

const FileInput = styled.input`
display: none;
`;

const ImageUploadContainer = styled.div`
border: 1px solid #ccc;
border-radius: 5px;
display: flex;
flex-direction: column;
align-items: center;
padding: 20px;
position: relative;
cursor: pointer;
 .drag-over {
    border-color: blue;
  }
 .remove-button {
  position: absolute;
  right: 3px;
  top: 3px;
 }
`;

const ImageUploadPlaceholder = styled.div`
width: 100%;
height: 120px !important;
display: flex;
justify-content: center;
align-items: center;
font-size: 18px;
position: relative;
color: #ccc;
background-color: #fafafa;
border: 2px dashed #ccc;
border-radius: 5px;
`;

const ImageUploadPreview = styled.div`
width: 100%;
height: 200px;
overflow: hidden;
position: relative;
display: flex;
cursor: default;
flex-direction: column;
align-items: center;
margin: 10px;
.wrapper {
 > * {
  position: absolute;
  height: 200px;
  min-width: 250px;
  max-width: 420px;
  object-fit: cover;
  border: 1px dashed;
  border-radius: 10px;
  padding: 10px;
  right: 35px;
  }
 }
`;

const ImageUploadButton = styled.div`
width: 100%;
height: 40px;
display: flex;
justify-content: center;
align-items: center;
font-size: 18px;
color: #666;
background-color: #eee;
border: none;
border-radius: 5px;
cursor: pointer;
transition: all 0.3s;

&:hover {
  background - color: #ddd;
}
`;

const FileInfoLabel = styled.div`
  font-size: 14px;
  max-width: 250px;
  color: #333;
  margin-right: 20px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  float: left;
`;

const LabelWrapper = styled.div`
max-width: 270px;
position: absolute;
left: 8px;
height: auto;
padding: 8px;
background-color: #eee;
border-radius: 5px;
`

const StyledRefreshButton = styled(Button)`
position: absolute;
left: 10px;
top: 150px;
`
export const FileUpload = {
  FileInput,
  ImageUploadButton,
  ImageUploadContainer,
  ImageUploadPlaceholder,
  ImageUploadPreview,
  StyledRefreshButton,
  FileInfoLabel,
  LabelWrapper
}